<template>
  <v-row justify="center">
    <v-img v-if="uploadLink" :src="uploadLink" max-height="700" contain />
    <v-skeleton-loader v-else width="700" class="mx-auto" type="image" />
  </v-row>
</template>

<script>
import MediaApi from '@/api/mediaApi';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapAccountState } = createNamespacedHelpers('account');

export default {
  props: {
    screen: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      uploadLink: null
    };
  },
  computed: mapAccountState(['token']),
  async mounted() {
    try {
      if (this.screen.url) {
        const response = await new MediaApi(this.token).get(this.screen.url);
        this.uploadLink = `${response.data.result.uri}${response.data.result.sasBlobToken}`;
      }
    } catch (err) {
      console.error(err);
      // TODO: handle
    }
  }
};
</script>
